import { Link } from 'react-router-dom'
import { trackFunnel } from '@/lib/funnel'
import { landingHeaderCtaClass } from '@/components/landing/landingStyles'
import { LandingLocaleSwitcher } from '@/components/landing/LandingLocaleSwitcher'
import { useLandingCopy } from '@/hooks/useGuestLocale'
import { BrandMark } from '@/components/layout/BrandMark'

export function LandingHeader() {
  const copy = useLandingCopy()

  return (
    <header className="sticky top-0 z-30 border-b border-slate-900/[0.05] bg-white/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-3.5 sm:px-6">
        <Link to="/" className="tracking-tight text-foreground">
          <BrandMark nameClassName="text-lg font-semibold text-foreground" />
        </Link>
        <div className="flex items-center gap-2.5 sm:gap-4">
          <LandingLocaleSwitcher />
          <Link
            to="/login"
            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            {copy.signIn}
          </Link>
          <Link
            to="/register"
            className={landingHeaderCtaClass}
            onClick={() => trackFunnel('REGISTER_CLICK', { source: 'header' })}
          >
            {copy.getStarted}
          </Link>
        </div>
      </div>
    </header>
  )
}
